import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Box, Typography } from "@mui/material";
import "./VideoCorousel.css";

const VideoCorousel = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    // Static video data (replace URLs with your actual local video paths)
    const staticVideos = [
      {
        name: "Luxury Homes Overview",
        // url: "/assets/main-video-2.mp4",
        url: "/assets/new-home-page-video.mp4",
      },
      // {
      //   name: "Urban Casa Projects",
      //   url: "/assets/videos/video2.mp4",
      // },
      // {
      //   name: "Client Testimonials",
      //   url: "/assets/videos/video3.mp4",
      // },
      // Add more videos as needed
    ];

    setVideos(staticVideos);
  }, []);

  return (
    <Box className="video-carousel-container">
      <Swiper
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        spaceBetween={50}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop={true}
        effect="fade"
        className="video-swiper-container"
      >
        {videos.map((video, index) => (
          <SwiperSlide key={index} className="video-swiper-slide">
            <video autoPlay loop muted className="video-slide">
              <source src={video.url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <Box className="video-overlay"></Box>

            <Box className="video-text">
              <Typography variant="h2" className="video-title">
                {video.name}
              </Typography>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default VideoCorousel;

